module.exports = __webpack_public_path__ + "static/media/business-house-l.b822cdd4.png";